module.exports = __webpack_public_path__ + "static/media/cycle-count.5e9a57ba.svg";